import Vue from 'vue'
import Vuex from 'vuex'

import userStore from "@/store/user";
import giftStore from "@/store/gift";
import friendStore from "@/store/friend";

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        user: userStore,
        gift: giftStore,
        friend: friendStore,
    },
    state: {
        isOffline: false,

        launchParams: [],
        launchURL: '',
        device: '',

        panelHeader: {
            isBackArrowNeed: false,
            text: ""
        },

        history: {
            depth: 0,
        }
    },
    mutations: {
        setOffline(state, value) {
            state.isOffline = value;
        },
        setLaunchParams(state, params) {
            state.launchParams = params;
        },
        setLaunchURL(state, params) {
            state.launchURL = params;
        },
        setPanelHeaderArrowFlag(state, value) {
            state.panelHeader.isBackArrowNeed = value
        },
        setPanelHeaderText(state, value) {
            state.panelHeader.text = value
        },
        incrementHistoryDepth(state) {
            state.history.depth = state.history.depth + 1;
        },
        decrementHistoryDepth(state) {
            state.history.depth = state.history.depth - 1;
        }
    }
})
